import { ZodError, z } from 'zod';
import type { MessageFields } from '@/data/message/model';
import { RequestSchema, type RequestStatus } from '@/data/request/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

export type UpdateRequestArgs = { id: number } & Partial<{
  start_time: string;
  end_time: string;
  type_id: number;
  paid: boolean;
  message?: string;
  hours: number;
  status: RequestStatus;
}>;

export const updateRequest = createWiwAsyncThunk<z.infer<typeof UpdateRequestResponse>, UpdateRequestArgs>(
  'request/update',
  async (request, { rejectWithValue }) => {
    try {
      const response = await Monolith.url(`/requests/${request.id}`).put(request);
      return UpdateRequestResponse.parse(response);
    } catch (error) {
      if (error instanceof ZodError) {
        return rejectWithValue(error);
      }
      return rejectWithValue(parseAPIError(error));
    }
  },
);

export const UpdateRequestResponse = z.object({
  request: RequestSchema,
  // TODO: Add a schema for messages so we actually have zod validation on messages
  messages: z.array(z.custom<MessageFields>()),
});
